(function ($) {
	$(function () {
		$("input[name=city]").on("change", function () {
			let target	=	$(this).val();

			$(".areas .area .inner:visible").fadeOut();
			$(".areas .area .inner[data-name="+ target +"]").fadeIn(function () {
				$(".areas .area .inner").find("input").attr("disabled", true);
				$(".areas .area .inner:visible").find("input").attr("disabled", false);
			}).css({display: "flex"});
		}).filter(":checked").trigger("change");

		$("input[name=type]").on("change", function () {
			if($(this).val() == "rent") {
				$(".rentOnly").show();
				$(".tradeOnly").hide();
			}
			else {
				$(".rentOnly").hide();
				$(".tradeOnly").show();
			}
		}).filter(":checked").trigger("change");

		$("#Search").on("click first", function (e) {
			$(".result .item").show();

			$.each(["type", "kind", "city"], function (key, type) {
				let $input	=	$("input[name='"+ type +"']:checked");
				let value	=	$input.val() || "";

				if(value != "") {
					$(".result .item[data-"+type+"!='"+value+"']").hide();
				}
			});

			$.each(["area[]"], function (key, type) {
				let $inputs	=	$("input[name='"+ type +"']:checked");
				
				if($inputs.length != 0) {
					$(".result .item").each(function () {
						let $target	=	$(this);
						
						$inputs.each(function () {
							if($target.attr("data-area") == $(this).val()) {
								$target.attr("data-passed", "1");
							}
						});
					});

					$(".result .item[data-passed!=1]").hide();
					$(".result .item[data-passed]").removeAttr("data-passed");
				}
			});

			if(e.type == "first") {
				$(".result .item:visible").each(function (key, item) {
					if(key >= 12) {
						$(this).hide();
					}
				});
			}

			if($(".result .item:visible").length != 0) {
				$(".result .item.spacer").show();
			}
			else {
				$(".result .item.nothing").show();
			}
		}).trigger("first");
	});

	let media	=	matchMedia('(min-width: 961px)');

	$(".photos").show();

	$(media).on("change", function (e) {
		if(e.target.matches) {
			$(".photos > dd").slick({
				autoplay	:	true,
				fade		:	true,
				arrows		:	false,
			});
		}
		else {
			$(".photos > dd.slick-initialized").slick("unslick");
		}
	}).trigger("change");

	function changeMV() {
		$(".backgrounds .background:last").fadeOut(function () {
			let $target	=	$(this);

			$target.closest(".backgrounds").prepend($target);
			$target.show();
		});
	}

	setInterval(changeMV, 10000);
	
})(jQuery);
